export const SERVICE_WORKER_FLAGS = ["offlineFeatures"] as const;
